import React from 'react';
import './CustomModal.css';

interface CustomModalProps {
  show: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  title: string;
  children: React.ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({ show, handleClose, handleConfirm, title, children }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <div className="custom-modal-header">
          <h4>{title}</h4>
          <button onClick={handleClose} className="close-button">&times;</button>
        </div>
        <div className="custom-modal-body">
          {children}
        </div>
        <div className="custom-modal-footer">
          <button onClick={handleClose} className="modal-button secondary">No</button>
          <button onClick={handleConfirm} className="modal-button primary">Yes</button>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;